import { Icon } from "./Icon"

type Props = { quantity: number; maximum: number; onChange: (quantity: number) => void; disabled?: boolean }

export function QuantityStepper({ quantity, maximum, onChange, disabled = false }: Props) {
    return <div className="ah-stepper" role="group" aria-label="Quantity">
        <button type="button" aria-label="Decrease quantity" disabled={disabled || quantity <= 1} onClick={() => onChange(quantity - 1)}><Icon name="minus" /></button>
        <output aria-label="Quantity" aria-live="polite">{quantity}</output>
        <button type="button" aria-label="Increase quantity" disabled={disabled || quantity >= maximum} onClick={() => onChange(quantity + 1)}><Icon name="plus" /></button>
    </div>
}
